module.exports = __webpack_public_path__ + "img/completion0.5932ac94.svg";